import { getTransitionConfig } from '@/utils/transition';

export function onboardingQuestionnaireId(store, apptimize) {
  let id;
  if (apptimize) {
    id = apptimize.checkExperiments({
      experimentName: 'Simplified Business Model',
      int: 'onboardingQuestionnaireID',
      defaultVal: null,
      matcher: /Simplified Business Model/,
    });
  }

  const webPv = store.getters['productVars/get']['webOnboardingQuestionnaire'];
  if (!id && webPv && webPv.value) {
    id = webPv.value;
  }

  const pv = store.getters['productVars/get']['onboardingQuestionnaire'];
  if (!id && pv && pv.value) {
    id = pv.value;
  }
  return id;
}

export function transitionQuestionnaireId(store, classification = store.getters['session/classification']) {
  const transition = getTransitionConfig(store, classification);
  if (transition) {
    return transition.questionnaire_id;
  }
}

export function shouldEnterOnboardingQuestionnaire(store, apptimize) {
  const id = onboardingQuestionnaireId(store, apptimize);
  if (id && store.getters['session/authenticated']) {
    const classificationId = store.getters['user/get']?.classificationId;
    if (classificationId) return false;

    let state = store.getters['questionnaireUserStates/all'].find(s => s.questionnaireId == id);
    if (state) {
      // if no last delivered question, user is done
      return state.lastDeliveredQuestionId;
    } else {
      // empty state means user hasn't completed this yet
      return true;
    }
  }
}

export function shouldEnterTransitionQuestionnaire(store) {
  const id = transitionQuestionnaireId(store);
  if (id && store.getters['session/authenticated']) {
    let state = store.getters['questionnaireUserStates/all'].find(s => s.questionnaireId == id);
    if (state) {
      // if no last delivered question, user is done
      return state.lastDeliveredQuestionId;
    }
  }
}

export function shouldEnterQuestionnaire(store, apptimize) {
  if (store.getters['app/isMasteryApp']) {
    return shouldEnterOnboardingQuestionnaire(store, apptimize) || shouldEnterTransitionQuestionnaire(store);
  }
}

export function startTransitionQuestionnaire() {
  const data = {};
  const questionnaireId = transitionQuestionnaireId(this.$store);
  this.$store.dispatch('questionnaires/update', { data, questionnaireId }).then(response => {
    this.$router.push({ name: 'mastery#questionnaire', params: { step : 1 }});
  });
}
